import * as actions from './actions';

const initialState = {
  hasMessage: false,
  hasFailedAction: false,
  message: {
    buttons: []
  },
  failedAction: {},
  translateLanguageContent: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_MESSAGE:
      return {
        ...state,
        hasMessage: true,
        message: action.message
      };
    case actions.SET_FAILED_ACTION:
      return {
        ...state,
        hasFailedAction: true,
        failedAction: action.failedAction
      };
    case actions.CLEAR_MESSAGE:
      return {
        ...initialState,
        translateLanguageContent: state.translateLanguageContent
      };
    case actions.SET_TRANSLATE_LANGUAGE_CONTENT:
      return {
        ...state,
        translateLanguageContent: action.translateLanguageContent
     };
    default:
      return state;
  }
};
